import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';

const VerticalPipe = ({ height }) => (
  <span className={styles.vertPipe} style={{ height: `${height}px` }}>&nbsp;</span>
);

VerticalPipe.defaultProps = {
  height: 15,
};

VerticalPipe.propTypes = {
  height: PropTypes.number,
};

export default VerticalPipe;
